module.exports = __webpack_public_path__ + "media/images/avatar-6b55e5a1cffe80c22ea6cd4d64d25e94.svg";